
import React, { useState, useEffect } from 'react'
import Swal from "sweetalert2";
import Axios from 'axios';
import { API_BASE_URL, INSERT_USER } from '../../../Config';

const AddUsers = () => {

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setConfirmPassword] = useState(false);
    // const [storeData, setStoreData] = useState(false);

    const handleTogglePassword = () => {
      setShowPassword((prevShowPassword) => !prevShowPassword);
    };
    const handleToggleConfirmPassword = () => {
        setConfirmPassword((prevShowPassword) => !prevShowPassword);
    };

    const [userDataSession, setUserDataSession] = useState([]);
    const [selectedEmpRole, setSelectedEmpRole] = useState(null);
    const [selectedEmpGender, setSelectedEmpGender] = useState(null);
    const [confirmPWD, setConfrimPWD] = useState([]);
    const [rolesDDL, setRolesDDL] = useState([]);
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        const rolesData = JSON.parse(sessionStorage.getItem('filteredDDLData_Roles'));
        // const storesData = JSON.parse(sessionStorage.getItem('filteredDDLData_Stores'));

        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
            setRolesDDL(rolesData);
            // setStoreData(storesData);
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    const initialFormData = {
        Id: 0,
        OrgId: userDataSession.OrgId,
        RoleId: selectedEmpRole,
        Name: "",
        Password: "",
        Mobile: "",
        Email: "",
        IsMobile: 0,
        CreatedBy: userDataSession.UserId,
        Gender: ""
    };

    const [formData, setFormData] = useState(initialFormData);

    const handleCancel = () => {
        setFormData(initialFormData);
        setConfirmPassword('');
        setSelectedEmpGender('');
        setSelectedEmpRole('');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleEmpRoleChange = (e) => {
        const selectedOption = e.target.value
        setSelectedEmpRole(selectedOption);
    };

    const handleIsMobileChange = (e) => {
        const isChecked = e.target.checked;
        setFormData({
            ...formData,
            IsMobile: isChecked ? 1 : 0
        });
    };      

    // const handleEmpStoreChange = (e) => {
    //     const selectedOption = e.target.value
    //     setSelectedEmpStore(selectedOption);
    // };

    const handleEmpGenderChange = (e) => {
        const selectedOption = e.target.value
        setSelectedEmpGender(selectedOption);
    };

    const handleConfPWDChange = (e) => {
        const selectedOption = e.target.value
        setConfrimPWD(selectedOption);
    };

    const handleSubmit = (e) => {

        e.preventDefault();

        // console.log(formData.Password != confirmPWD, formData.Password, confirmPWD)

        if (formData.Password !== confirmPWD) {
            Swal.fire({
                title: "Error",
                text: "Password and Confirm Password do not match.",
                icon: "error",
            });
            return;
        }

        setSubmitBtnLoading(true);
        formData.OrgId = userDataSession.OrgId,
        formData.CreatedBy = userDataSession.UserId,
        formData.RoleId = parseInt(selectedEmpRole),
        formData.Gender = parseInt(selectedEmpGender),
        // formData.Store = selectedEmpStore,

        console.log(formData, 'data sending to api');

        Axios.post(`${API_BASE_URL}${INSERT_USER}`, formData)
            .then(response => {
                console.log(response.data, 'rrrrrrrr');

                if (response.data.ResultData[0]['Status'] == 'Success') {
                    setSubmitBtnLoading(false);

                    // Show success message
                    Swal.fire({
                        title: `User added Successfully.`,
                        icon: "success",
                    }).then((result) => {
                        if (result.isConfirmed || result.isDismissed) {
                            window.location.reload();
                        }
                    });
                } else {
                    setSubmitBtnLoading(false);

                    Swal.fire({
                        title: "Error",
                        text: "Failed to Request Submit.",
                        icon: "error",
                    });
                }

                setFormData({
                    ...formData,
                    Name: "",
                    Description: "",
                    Code: ""
                });
            })

            .catch(error => {
                setSubmitBtnLoading(false);
                // Handle error
                console.error('Error adding user:', error);
            });
    };
  
    return (
        <div>
            {/* Add User */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightUserAdd"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: '300px', maxWidth: '40%' }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Add User</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        onClick={handleCancel}
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <form onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder='Enter user name'
                                    name="Name"
                                    value={formData.Name || ''}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                <label className="form-label">Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder='Enter email address'
                                    name="Email"
                                    value={formData.Email || ''}
                                    onChange={handleChange}
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                <label className="form-label">Mobile No</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder='Enter mobile no'
                                    name="Mobile"
                                    value={formData.Mobile || ''}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                <label className="form-label">Employee Type</label>
                                <select
                                    className='form-select'
                                    value={selectedEmpRole || ''} 
                                    onChange={handleEmpRoleChange}
                                >
                                    <option>Choose employee role</option>
                                    {rolesDDL && rolesDDL.map((item, index) => (
                                        <option key={index} value={item.ItemId}>{item.ItemValue}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                <label className="form-label">Gender</label>
                                <select
                                    className='form-select'
                                    value={selectedEmpGender || ''} 
                                    onChange={handleEmpGenderChange}
                                >
                                    <option>Choose gender</option>
                                    <option value="1">Male</option>
                                    <option value="0">Female</option>
                                </select>
                            </div>
                            <div className="col-lg-6">
                                <div className="input-blocks">
                                    <label>Password</label>
                                    <div className="pass-group">
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            className="pass-input"
                                            name="Password"
                                            value={formData.Password || ''}
                                            onChange={handleChange}
                                            placeholder="Enter password"
                                            autoComplete="new-password"
                                        />
                                        <span
                                            className={`fas toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                            onClick={handleTogglePassword}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="input-blocks">
                                    <label>Confirm Passworrd</label>
                                    <div className="pass-group">
                                        <input
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            className="pass-input"
                                            value={confirmPWD}
                                            onChange={handleConfPWDChange}
                                            placeholder="Comfirm password"
                                        />
                                        <span
                                            className={`fas toggle-password ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                            onClick={handleToggleConfirmPassword}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="input-blocks">
                                    <label>Mobile Access</label>
                                    <div className="pass-group">
                                        <input
                                            type="checkbox"
                                            checked={formData.IsMobile === 1}
                                            onChange={handleIsMobileChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer-btn">
                                <button
                                    type="button"
                                    className="btn btn-cancel me-2"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-submit"
                                >
                                    {submitBtnLoading ? 'Submitting..' : 'Submit'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
                   
    )
}

export default AddUsers
